export default __webpack_public_path__ + "static/media/shisui.0304b979.png";